'use client'

import React from 'react'
import { Button } from '@/components/ui/button'
import { AlertTriangle, RefreshCw } from 'lucide-react'

export default function Error({ reset }: { reset: () => void }) {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="mx-auto max-w-md text-center">
        <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-3xl bg-destructive/10">
          <AlertTriangle className="h-10 w-10 text-destructive" />
        </div>

        <h1 className="mb-3 text-2xl font-bold tracking-tight text-foreground">
          Er ging iets mis
        </h1>

        <p className="mb-8 text-muted-foreground">
          Er is een probleem opgetreden bij het laden van deze pagina. Dit kan een tijdelijk probleem zijn.
        </p>

        <Button
          onClick={() => reset()}
          size="lg"
          className="gap-2"
        >
          <RefreshCw className="h-4 w-4" />
          Opnieuw proberen
        </Button>
      </div>
    </div>
  )
}
